module.exports = __webpack_public_path__ + "img/upgrade.a34bee99.svg";